'use strict';

angular.module('shiftTraderApp')
  .directive('saNotePermissionIcon', [function(){
    return {
      restrict: 'A',
      require: '^saNote',
      template: '<i class="{{::PermissionIconCtrl.tooltipIconClass}}" tooltip-placement="left" uib-tooltip="{{::PermissionIconCtrl.tooltipText}}"></i>',
      controllerAs: 'PermissionIconCtrl',
      controller: ['$scope', 'saNotePermissionLevels', function($scope, saNotePermissionLevels) {
        var vm = this;

        function setIcon(iconClass, tooltipText) {
          vm.tooltipIconClass = iconClass;
          vm.tooltipText = tooltipText;
        }

        if (!$scope.NoteCtrl.note.parentId) {
          if ($scope.NoteCtrl.note.permission in saNotePermissionLevels) {
            var info = saNotePermissionLevels[$scope.NoteCtrl.note.permission];
            setIcon(info.iconClass, info.label);
          } else {
            setIcon('icon-question', 'Unknown');
          }
        } else {
          setIcon('icon-question', 'Unknown');
        }
      }],
      link: function(scope, elem, attr, parentCtrl) {
        scope.NoteCtrl = parentCtrl;
      }
    }
  }]);
